<template>
<v-app>

<v-navigation-drawer
      v-model="drawer"
      app
      clipped
      color="#6D9886"
    >


      <v-list subheader>
                              <v-subheader>Super Admin</v-subheader>


          <v-list-item >
              <v-list-item-action>
                <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'clientesman'}"> <v-icon>fas fa-smile</v-icon></router-link>
              </v-list-item-action>
              <v-list-item-content>
                  <v-list-item-title><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'clientesman'}">Clientes</router-link></v-list-item-title>
              </v-list-item-content>
          </v-list-item>
        <v-list-item >
          <v-list-item-action>
            <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'negociosman'}"> <v-icon>fas fa-briefcase</v-icon></router-link>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'negociosman'}">Negocios</router-link></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  <v-app-bar
      app
      clipped-left
      color="#393E46"
  >
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-toolbar-title>
      <router-link :to="{ name: 'homepage'}">

      <v-img
        alt="Tunay Logo"
        class="shrink mt-1 "
        contain
        min-width="100"
        src="@/assets/tunaywhitelogo.png"
        width="100"
    />
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
   <!-- <v-btn
        v-for="link in links"
        :key="link.url"
        color="white"
        text
        :href="link.href"
        rounded
        class="my-2 hidden-sm-only hidden-xs-only"
    >
      {{ link.url }}
    </v-btn> -->

    <loginbox/>
  </v-app-bar>
</v-app>
</template>
<script>
import { mapGetters } from "vuex";
import loginbox from '../modals/loginbox';

  export default {
    name: 'leftmenusuperadmin',
    components: {
      loginbox
    },
    data: () => ({
      drawer: null,
      teventos: localStorage.eventos,
  }),
  mounted(){
    this.armamenu();
  },
  methods: {
    armamenu(){
    this.teventos = this.cliente.eventos;
    localStorage.eventos = this.cliente.eventos;
    console.log(this.cliente);
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente: "cliente"
    })
  }
  }
</script>